import { useEffect, useState } from "react";

import { getAccessSnapshot, ACCESS_SNAPSHOT_EVENT } from "./accessSnapshot";

/**
 * Lee el acceso vigente y repinta cuando cambia.
 *
 * WHY existe como hook: el snapshot NO es un contexto de React a propósito —así
 * `<Can>` sigue siendo una función pura y no arrastra re-renderes por todo el
 * árbol—, pero quien decide si pinta o si pide datos sí necesita enterarse de
 * que los permisos ya llegaron. Este hook es ese puente, y nada más.
 *
 * WHY importa esperar a `loaded`: el primer render ocurre ANTES de que
 * `/me/permissions` conteste. Un componente que pregunta «¿puedo?» en ese
 * instante recibe un «no sé» que se parece demasiado a un «sí» — y se lanza a
 * pedir datos que el servidor le va a negar con un 403. Fue exactamente lo que
 * pasó con la campanita de avisos: la guarda estaba puesta, pero se evaluaba
 * medio segundo antes de que hubiera nada que evaluar.
 */
export const useAccesoVigente = () => {
  const [, repintar] = useState(0);

  useEffect(() => {
    const alCambiar = () => repintar(v => v + 1);
    window.addEventListener(ACCESS_SNAPSHOT_EVENT, alCambiar);
    return () => window.removeEventListener(ACCESS_SNAPSHOT_EVENT, alCambiar);
  }, []);

  return getAccessSnapshot();
};

export default useAccesoVigente;
